import React, { useState, useEffect } from 'react';
import { getOrderOrigins } from '../../../services/api/orderOrigins';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './OrderOriginSection.module.css';

const OrderOriginSection = ({ value, onChange, error }) => {
  const { t } = useLocalization();
  const [origins, setOrigins] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        setIsLoading(true);
        const data = await getOrderOrigins();
        setOrigins(data);
      } catch (err) {
        console.error('Failed to load order origins:', err);
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, []);

  if (isLoading) return null;

  const paidOrigins = origins.filter(o => o.type === 'paid');
  const organicOrigins = origins.filter(o => o.type === 'organic');

  const renderGroup = (label, groupOrigins) => (
    <div className={styles.group}>
      <div className={styles.groupLabel}>{label}</div>
      {groupOrigins.map(origin => (
        <button
          key={origin.key}
          type="button"
          className={`${styles.originButton} ${value === origin.key ? styles.originButtonActive : ''}`}
          onClick={() => onChange(value === origin.key ? null : origin.key)}
          title={origin.label}
        >
          <img src={origin.iconUrl} alt={origin.label} className={styles.originIcon} />
        </button>
      ))}
    </div>
  );

  return (
    <div className={styles.section}>
      {renderGroup(t('ecomOrders.paid') || 'Paid', paidOrigins)}
      {renderGroup(t('ecomOrders.organic') || 'Organic', organicOrigins)}
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};

export default OrderOriginSection;
